/* ==========================================================================
   Calda - product page behaviour
   Variant switching, media gallery + zoom, low stock and social proof,
   the bundle builder, the sticky add to cart bar and the main add to cart.

   Loaded only on templates that render sections/main-product.liquid.
   ========================================================================== */

function evoraProductPage() {
  'use strict';

  var theme = window.EvoraTheme;
  if (!theme) return;

  var $ = theme.helpers.$;
  var $$ = theme.helpers.$$;
  var Cart = theme.Cart;
  var Drawers = theme.Drawers;
  var formatMoney = theme.formatMoney;
  var setButtonLoading = theme.setButtonLoading;
  var toast = theme.toast;

  var config = window.Evora || {};
  var strings = config.strings || {};
  var settings = config.settings || {};

  var section = $('[data-product-section]');
  if (!section) return;

  var variants = readVariants();
  var currentVariant = null;

  function readVariants() {
    var node = $('[data-variant-data]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  /* ------------------------------------------------------ Variant picker - */

  function selectedOptions() {
    var picker = $('[data-variant-picker]');
    if (!picker) return null;

    var groups = $$('.variant-picker__group', picker);
    return groups.map(function (group) {
      var checked = $('[data-option-value]:checked', group);
      return checked ? checked.value : null;
    });
  }

  function findVariant(options) {
    if (!options) return variants[0];

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var matches = true;

      for (var j = 0; j < options.length; j++) {
        if (variant.options[j] !== options[j]) {
          matches = false;
          break;
        }
      }

      if (matches) return variant;
    }

    return null;
  }

  function priceMarkup(variant) {
    var onSale = variant.compare_at_price > variant.price;
    var html = '<span class="price__row">';

    if (onSale) {
      html += '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
      html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';

      var percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
      html += '<span class="price__percent">-' + percent + '%</span>';
    } else {
      html += '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
    }

    html += '</span>';

    if (onSale) {
      html +=
        '<span class="price__save">' +
        savingsLabel(formatMoney(variant.compare_at_price - variant.price)) +
        '</span>';
    }

    return html;
  }

  // The "Save X" wording comes from the locale file, rendered once in
  // theme.liquid with an [amount] placeholder, so it stays translated.
  function savingsLabel(amount) {
    var template = strings.saveAmount || '[amount]';
    return template.replace('[amount]', amount);
  }

  function updatePrice(variant) {
    var container = $('[data-product-price]');
    if (!container) return;

    var price = $('.price', container);
    if (!price) return;

    if (!variant || !variant.available) {
      price.innerHTML = '<span class="price__unavailable">' + strings.soldOut + '</span>';
      price.classList.remove('price--on-sale');
      return;
    }

    price.innerHTML = priceMarkup(variant);
    price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);

    var stickyPrice = $('[data-sticky-price] .price');
    if (stickyPrice) {
      stickyPrice.innerHTML = priceMarkup(variant);
      stickyPrice.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
    }
  }

  function updateButtons(variant) {
    var idInput = $('[data-variant-id-input]');
    var submit = $('[data-add-to-cart]');
    var submitText = $('[data-add-to-cart-text]');
    var stickyButton = $('[data-sticky-add]');
    var stickyText = $('[data-sticky-add-text]');
    var payment = $('[data-payment-button]');

    var available = !!(variant && variant.available);
    var label = variant ? (available ? strings.addToCart : strings.soldOut) : strings.unavailable;

    if (idInput) {
      idInput.value = variant ? variant.id : '';
      idInput.disabled = !variant;
    }

    if (submit) submit.disabled = !available;
    if (submitText) submitText.textContent = label;
    if (stickyButton) stickyButton.disabled = !available;
    if (stickyText) stickyText.textContent = label;
    if (payment) payment.style.display = available ? '' : 'none';
  }

  function updateSelectedLabels(options) {
    if (!options) return;

    options.forEach(function (value, index) {
      var label = $('[data-option-selected="' + index + '"]');
      if (label && value) label.textContent = value;
    });
  }

  function updateOptionAvailability(options) {
    if (!options) return;

    var groups = $$('.variant-picker__group');

    groups.forEach(function (group, groupIndex) {
      $$('[data-option-value]', group).forEach(function (input) {
        var candidate = options.slice();
        candidate[groupIndex] = input.value;

        var possible = variants.some(function (variant) {
          for (var i = 0; i < candidate.length; i++) {
            if (i !== groupIndex && candidate[i] === null) continue;
            if (variant.options[i] !== candidate[i]) return false;
          }
          return variant.available;
        });

        var label = group.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !possible);
      });
    });
  }

  function updateUrl(variant) {
    if (!variant || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function updateLowStock(variant) {
    var urgency = $('[data-urgency]');
    var stock = $('[data-low-stock]', urgency || document);
    if (!urgency || !stock || !variant) return;

    var threshold = parseInt(urgency.dataset.lowStockThreshold, 10) || 0;
    var tracked = !!variant.inventory_management;
    var quantity = variant.inventory_quantity;
    var show = tracked && quantity > 0 && quantity <= threshold;

    stock.hidden = !show;
    if (!show) return;

    var text = $('[data-low-stock-text]', stock);
    var bar = $('[data-low-stock-bar]', stock);

    if (text) {
      // Swap only the number so the merchant's own wording survives.
      text.textContent = text.textContent.replace(/\d+/, quantity);
    }

    if (bar) bar.style.width = Math.min(100, (quantity / threshold) * 100) + '%';
  }

  function onVariantChange() {
    var options = selectedOptions();
    var variant = findVariant(options);

    currentVariant = variant;

    updateSelectedLabels(options);
    updateOptionAvailability(options);
    updatePrice(variant);
    updateButtons(variant);
    updateLowStock(variant);
    updateUrl(variant);
    showVariantMedia(variant);
    updateBundleTotal();
  }

  function bindVariantPicker() {
    var picker = $('[data-variant-picker]');
    if (!picker) {
      currentVariant = variants[0] || null;
      return;
    }

    picker.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-value]')) onVariantChange();
    });

    onVariantChange();
  }

  /* ---------------------------------------------------------- Gallery ---- */

  function showVariantMedia(variant) {
    if (!variant || !variant.featured_media_id) return;

    var thumb = $('[data-gallery-thumb][data-media-id="' + variant.featured_media_id + '"]');
    if (thumb) goToMedia(parseInt(thumb.dataset.index, 10) || 0);
  }

  function goToMedia(index) {
    var track = $('[data-gallery-track]');
    if (!track) return;

    var slides = $$('[data-gallery-slide]', track);
    var slide = slides[index];
    if (!slide) return;

    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    setActiveMedia(index);
  }

  function setActiveMedia(index) {
    $$('[data-gallery-slide]').forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });

    $$('[data-gallery-thumb]').forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    $$('[data-gallery-dot]').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function bindGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;

    var track = $('[data-gallery-track]', gallery);

    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToMedia(parseInt(thumb.dataset.index, 10) || 0);
      });
    });

    $$('[data-gallery-dot]', gallery).forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToMedia(parseInt(dot.dataset.index, 10) || 0);
      });
    });

    if (track) {
      track.addEventListener(
        'scroll',
        theme.helpers.debounce(function () {
          var slides = $$('[data-gallery-slide]', track);
          var center = track.scrollLeft + track.clientWidth / 2;
          var closest = 0;
          var shortest = Infinity;

          slides.forEach(function (slide, i) {
            var slideCenter = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;
            var distance = Math.abs(slideCenter - center);
            if (distance < shortest) {
              shortest = distance;
              closest = i;
            }
          });

          setActiveMedia(closest);
        }, 80)
      );
    }

    // Zoom
    var modal = $('[data-zoom-modal]');
    if (!modal) return;

    var image = $('[data-zoom-image]', modal);

    gallery.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-gallery-zoom]');
      if (!trigger || !image) return;

      image.src = trigger.dataset.zoomSrc;
      image.alt = trigger.dataset.zoomAlt || '';

      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('drawer-open');

      var close = $('[data-zoom-close]', modal);
      if (close) close.focus();
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-zoom-close]') || event.target === modal) {
        theme.closeZoom(modal);
      }
    });
  }

  /* ----------------------------------------------------- Social proof ---- */

  function initViewers() {
    var urgency = $('[data-urgency]');
    if (!urgency) return;

    var node = $('[data-viewers]', urgency);
    var text = $('[data-viewers-text]', urgency);
    if (!node || !text) return;

    var min = parseInt(urgency.dataset.viewersMin, 10) || 5;
    var max = parseInt(urgency.dataset.viewersMax, 10) || 20;
    if (max < min) max = min;

    // The wording comes from the locale file's plural form, which still
    // carries its {{ count }} placeholder when rendered without a count.
    var template = strings.viewingNow;
    if (!template) return;

    function render() {
      var count = Math.floor(Math.random() * (max - min + 1)) + min;
      text.textContent = template.replace(/\{\{\s*count\s*\}\}/, count);
      node.hidden = false;
    }

    render();
    setInterval(render, 12000);
  }

  /* ---------------------------------------------------------- Bundle ----- */

  function bundleInputs() {
    return $$('[data-bundle-input]');
  }

  function updateBundleTotal() {
    var bundle = $('[data-bundle]');
    if (!bundle) return;

    var discount = parseFloat(bundle.dataset.discountPercent) || 0;
    var totalNode = $('[data-bundle-total]', bundle);
    var originalNode = $('[data-bundle-original]', bundle);

    var subtotal = 0;

    bundleInputs().forEach(function (input) {
      if (!input.checked) return;

      // The main product's row follows the currently selected variant.
      var isMain = input === bundleInputs()[0];
      var price = isMain && currentVariant ? currentVariant.price : parseInt(input.dataset.price, 10) || 0;
      subtotal += price;
    });

    var discounted = Math.round(subtotal * (1 - discount / 100));

    if (totalNode) totalNode.textContent = formatMoney(discounted);

    if (originalNode) {
      var showOriginal = discount > 0 && subtotal > 0;
      originalNode.hidden = !showOriginal;
      if (showOriginal) originalNode.textContent = formatMoney(subtotal);
    }
  }

  function bindBundle() {
    var bundle = $('[data-bundle]');
    if (!bundle) return;

    bundle.addEventListener('change', function (event) {
      if (event.target.closest('[data-bundle-input]')) updateBundleTotal();
    });

    var addButton = $('[data-bundle-add]', bundle);
    var errorNode = $('[data-bundle-error]', bundle);

    if (!addButton) return;

    addButton.addEventListener('click', function () {
      var items = [];

      bundleInputs().forEach(function (input) {
        if (!input.checked) return;

        var isMain = input === bundleInputs()[0];
        var id = isMain && currentVariant ? currentVariant.id : parseInt(input.dataset.variantId, 10);
        if (id) items.push({ id: id, quantity: 1 });
      });

      if (!items.length) {
        if (errorNode) errorNode.hidden = false;
        return;
      }

      if (errorNode) errorNode.hidden = true;
      setButtonLoading(addButton, true);

      Cart.add(items, bundle.dataset.discountCode || null)
        .then(function (data) {
          Cart.renderSections(data);
          toast(strings.added);
          if (settings.cartDrawer) Drawers.open('cart');
        })
        .catch(function (error) {
          toast(error.message || strings.cartError);
        })
        .finally(function () {
          setButtonLoading(addButton, false);
        });
    });

    updateBundleTotal();
  }

  /* ------------------------------------------------------ Add to cart ---- */

  // Line item properties from the product form — the custom colour request and
  // anything else named properties[…] added later. The cart is updated over the
  // Ajax API rather than by posting the form, so these have to be collected and
  // sent with the item; a plain input alone would never reach the cart. Empty
  // boxes are skipped, which is what keeps the field optional.
  function formProperties() {
    var form = $('[data-product-form]');
    if (!form) return null;

    var properties = {};
    var found = false;

    $$('[name^="properties["]', form).forEach(function (field) {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;

      var open = field.name.indexOf('[');
      var close = field.name.lastIndexOf(']');
      var name = open > -1 && close > open ? field.name.slice(open + 1, close) : '';
      var value = (field.value || '').trim();

      if (!name || !value) return;
      properties[name] = value;
      found = true;
    });

    return found ? properties : null;
  }

  function addCurrent(button, quantity) {
    var idInput = $('[data-variant-id-input]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    var errorNode = $('[data-product-form-error]');
    if (errorNode) errorNode.hidden = true;

    setButtonLoading(button, true);

    var item = { id: Number(variantId), quantity: quantity || 1 };
    var properties = formProperties();
    if (properties) item.properties = properties;

    Cart.add([item])
      .then(function (data) {
        Cart.renderSections(data);
        toast(strings.added);
        if (settings.cartDrawer) Drawers.open('cart');
      })
      .catch(function (error) {
        if (errorNode) {
          errorNode.textContent = error.message || strings.cartError;
          errorNode.hidden = false;
        } else {
          toast(error.message || strings.cartError);
        }
      })
      .finally(function () {
        setButtonLoading(button, false);
      });
  }

  function bindProductForm() {
    var form = $('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var quantityInput = $('[data-quantity-input]', form);
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      addCurrent($('[data-add-to-cart]', form), quantity);
    });
  }

  /* --------------------------------------------------- Sticky add bar ---- */

  function bindStickyBar() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-add-to-cart]');

    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Visible only once the main button has scrolled off the top.
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
          bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(anchor);

    var stickyButton = $('[data-sticky-add]', bar);
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        addCurrent(stickyButton, 1);
      });
    }
  }

  /* ------------------------------------------------------------- Init ---- */

  function init() {
    bindVariantPicker();
    bindGallery();
    initViewers();
    bindBundle();
    bindProductForm();
    bindStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

// Everything above needs window.EvoraTheme from theme.js. theme.js is loaded
// from <head> so it normally runs first, but if the two are ever reordered,
// wait for DOMContentLoaded — which fires only after every deferred script has
// run — instead of quietly doing nothing, which is how this page once lost its
// variant switching with no console error to show for it.
if (window.EvoraTheme) {
  evoraProductPage();
} else {
  document.addEventListener('DOMContentLoaded', evoraProductPage);
}
